import { useQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetVariableContractDetails,
  GetVariableContractDetailsVariables
} from '@/graphql/contracts/_generated_/getVariableContractDetails.query';
import GetVariableContractDetailsQuery from '@/graphql/contracts/getVariableContractDetails.query.gql';
import { notificationService } from '@/services/notification/notification.client';


export default function useGetVariableContractDetails(contractId: UUID) {
  const { data, error, loading, } = useQuery<GetVariableContractDetails, GetVariableContractDetailsVariables>(
    GetVariableContractDetailsQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'cache-and-network',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      variables: { contractId }
    }
  );

  return {
    variableContract: data?.variableContractLinesSummary,
    isVariableContractLoading: loading,
    errorLoadingVariableContract: error,
  } as const;
}
